import type { ReactNode } from "react";
import { cn } from "../../lib/cn.js";

export interface PageHeaderProps {
  title: string;
  description?: ReactNode;
  breadcrumbs?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({ title, description, breadcrumbs, actions, className }: PageHeaderProps) {
  return (
    <header
      className={cn(
        "mb-7 flex flex-col gap-4 border-b border-border-subtle pb-5 sm:flex-row sm:items-start sm:justify-between",
        className
      )}
    >
      <div className="space-y-1 min-w-0">
        {breadcrumbs && <div className="mb-2">{breadcrumbs}</div>}
        <h1 className="font-display text-2xl font-semibold tracking-tight text-content-primary sm:text-3xl">{title}</h1>
        {description && <div className="max-w-3xl text-sm leading-6 text-content-secondary">{description}</div>}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </header>
  );
}

export function PageBody({
  className,
  children,
  constrained,
}: {
  className?: string;
  children: ReactNode;
  constrained?: boolean;
}) {
  return (
    <main
      className={cn(
        "mx-auto w-full px-4 py-8 pb-[calc(2rem+var(--mobile-nav-offset,0px))] sm:px-6 lg:px-8",
        constrained ? "max-w-[var(--page-max-width)]" : "max-w-[var(--page-wide-max-width)]",
        className
      )}
    >
      {children}
    </main>
  );
}
